// Camera position standing in front of the pipe wall, confirmed 2026-08-15.
export const KIMBARK_BATHROOM_CAMERA = {
  pos: [0.116, 2.450, 1.622] as [number, number, number],
  lookAt: [-5.381, 3.581, 7.323] as [number, number, number],
};

// Pipe skeleton extracted from the Kimbark bathroom (scan 3) via SI.
// Coordinates are in raw splat space (Z-up), matching the sceneQuaternion convention
// used by MultiSceneViewer's SplatMeshes (Euler -PI/2 around X → Z becomes world Y).
export interface XRayPipeSegment {
  name: string;
  vertices: [number, number, number][];
}

export interface XRayPipeData {
  segments: XRayPipeSegment[];
  // World-space position to fly to when the user wants to view the pipes
  viewpoint?: [number, number, number];
  // World-space window used to reveal the exposed scan through the finished scan.
  peekBounds: {
    min: [number, number, number];
    max: [number, number, number];
  };
  // Optional row-major 4×4 matrix that converts raw segment vertices into Three.js
  // world space (Y-up). When absent, vertices are assumed to be in world space already.
  // For the Kimbark bathroom, this is Kimbark6_Kimbark3_transform × Euler(-π/2,0,0):
  // raw-K3-Z-up → K6-raw-Z-up → world-Y-up.
  rawToWorldMatrix?: readonly number[];
}

export const KIMBARK_BATHROOM_XRAY: XRayPipeData = {
  viewpoint: KIMBARK_BATHROOM_CAMERA.pos,
  peekBounds: {
    // Expanded to cover the full back wall — original narrow sample X[-2.35,-0.32]
    // only revealed the right portion near the vanity/toilet.
    min: [-5.0, 1.0, 0.5],
    max: [0.5, 4.5, 5.0],
  },
  // K3_raw → Three.js world (Y-up).
  // Composed from Kimbark6_Kimbark3_transform.txt (row-major, K3→K6 raw) ×
  // sceneQuaternion Euler(-π/2, 0, 0) [row0=K6row0, row1=K6row2, row2=-K6row1].
  // World-Z translation corrected from raw +2.435 to +1.165 to place tubes at
  // Z≈2.54, matching the scene-1 pipe-wall selection centre (Z[2.09,3.00]).
  rawToWorldMatrix: [
    -0.014677895647, -0.991345965009, -0.000285737046, -0.392640900354,
     0.011476105019, -0.000455664728,  0.991388135893,  0.077640570872,
    -0.991279578625,  0.014673603373,  0.011481592707,  1.165000000000,
     0,               0,               0,               1,
  ],
  segments: [
  {
    name: 'right_vertical',
    vertices: [
      [-1.3880555629730225, -0.019409650936722755, 1.7159572839736938],
      [-1.3880555629730225, -0.019409650936722755, 2.001275062561035],
      [-1.3880555629730225, -0.019409650936722755, 2.088324785232544],
      [-1.3880555629730225, -0.019409650936722755, 3.1600026844777886],
      [-1.3880555629730225, -0.019409650936722755, 4.373712062835693],
    ],
  },
  {
    name: 'main_horizontal',
    vertices: [
      [-1.4090007543563843, -0.10096585750579834, 3.1636624336242676],
      [-1.4053815603256226, -0.01864790916442871, 3.1600027084350586],
      [-1.3220514059066772, 1.87669038772583, 3.075735569000244],
      [-1.316866397857666, 1.9946235418319702, 3.0704922676086426],
    ],
  },
  {
    name: 'left_vertical',
    vertices: [
      [-1.3228176832199097, 1.8767240047454834, 1.5136520862579346],
      [-1.3228176832199097, 1.8767240047454834, 3.075735558278358],
      [-1.3228176832199097, 1.8767240047454834, 3.1535720825195312],
    ],
  },
  {
    name: 'lower_horiz_wide',
    vertices: [
      [-1.396366000175476, -0.4734955560415983, 2.088324785232544],
      [-1.396366000175476, -0.019409650936722755, 2.088324785232544],
      [-1.396366000175476, 0.5062123406678438, 2.088324785232544],
    ],
  },
  {
    name: 'lower_horiz_left',
    vertices: [
      [-1.3664144277572632, -0.01940965373069048, 1.7159572839736938],
      [-1.3664144277572632, 0.0001901090145111084, 1.7159572839736938],
      [-1.3664144277572632, 1.0950438976287842, 1.7159572839736938],
    ],
  },
  ],
};

export const KIMBARK_BATHROOM_PIPES = KIMBARK_BATHROOM_XRAY.segments;
